import PolicyPlainContent from "./PolicyPlainContent";

export default PolicyPlainContent;
